var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30585 8.04867C7.37414 7.9307 7.42916 7.81835 7.49935 7.71536C8.98664 5.58816 8.65845 3.87479 6.48253 2.3805C5.8584 1.95169 5.20012 1.88054 4.51339 2.19138C2.85347 2.94414 1.78163 4.93839 2.03773 6.76036C2.45888 9.7508 4.10362 12.084 6.19987 14.1325C8.13107 16.0201 10.3203 17.5143 13.0994 17.9488C14.9946 18.2465 16.9979 17.2222 17.7946 15.5107C18.2139 14.6082 17.9844 13.67 17.1686 13.0053C16.8765 12.7675 16.5673 12.5502 16.2713 12.3162C14.7859 11.1477 14.065 11.1159 12.6024 12.2694C12.1433 12.6308 11.8038 12.6888 11.2707 12.4023C9.41727 11.408 8.12158 9.94742 7.30395 8.0468L7.30585 8.04867Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.14ad01396725f9069de5287bb0ef8486.svg";
export { ForwardRef as ReactComponent };